"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.quotePreparation = void 0;
var _dayjs = _interopRequireDefault(require("dayjs"));
var _helpers = require("@PetSureAustralia/petsure-react-ui-library/distLib/helpers");
var _brands = require("../../../constants/brands");
var _quote = require("../../../helpers/quote");
var _constants = require("../../../constants/constants");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var checkRestrictedBreeds = function checkRestrictedBreeds(pets, restrictedBreeds) {
  return pets.some(function (pet) {
    return restrictedBreeds === null || restrictedBreeds === void 0 ? void 0 : restrictedBreeds[pet.species.toLowerCase()].includes(pet.breedCode);
  });
};
var preparePets = function preparePets(pets, _ref) {
  var aboutPet = _ref.aboutPet;
  var _ref2 = aboutPet !== null && aboutPet !== void 0 ? aboutPet : {},
    petDesexedDefault = _ref2.petDesexedDefault;
  return pets.map(function (pet) {
    var _pet$hasMemberDiscoun, _pet$hasPromoDiscount, _pet$hasMultiplePetDi;
    return {
      hasMemberDiscount: (_pet$hasMemberDiscoun = pet.hasMemberDiscount) !== null && _pet$hasMemberDiscoun !== void 0 ? _pet$hasMemberDiscoun : false,
      hasPromoDiscount: (_pet$hasPromoDiscount = pet.hasPromoDiscount) !== null && _pet$hasPromoDiscount !== void 0 ? _pet$hasPromoDiscount : false,
      hasMultiplePetDiscount: (_pet$hasMultiplePetDi = pet.hasMultiplePetDiscount) !== null && _pet$hasMultiplePetDi !== void 0 ? _pet$hasMultiplePetDi : false,
      breed: pet.breed,
      breedCode: pet.breedCode,
      desexed: petDesexedDefault,
      gender: pet.gender,
      genderId: pet.genderId,
      petDOB: (0, _helpers.IsValidDate)(pet.petDOB) ? (0, _helpers.DateToShortIsoString)(pet.petDOB) : null,
      petName: pet.petName,
      petNumber: pet.petNumber,
      species: pet.species,
      speciesCode: pet.speciesCode
    };
  });
};
var handleGlm3 = function handleGlm3(glm, owner) {
  var basicOwnerDetails = glm.basicOwnerDetails,
    version = glm.version;
  var _ref3 = basicOwnerDetails !== null && basicOwnerDetails !== void 0 ? basicOwnerDetails : {},
    ownerBirthdateInput = _ref3.ownerBirthdateInput;
  var isGlm3 = version === 3;
  if (isGlm3 && owner.dateofBirth === null) {
    return ownerBirthdateInput === null || ownerBirthdateInput === void 0 ? void 0 : ownerBirthdateInput.defaultValue;
  }
  if (isGlm3 && owner.dateofBirth !== null) {
    return (0, _helpers.DateToShortIsoString)(owner.dateofBirth);
  }
  if (!isGlm3 && (0, _helpers.IsValidDate)(owner.dateofBirth)) {
    return (0, _helpers.DateToShortIsoString)(owner.dateofBirth);
  }
  return null;
};
var prepareOwner = function prepareOwner(owner, _ref4) {
  var _owner$isEmailCommuni, _owner$marketingConse;
  var pets = _ref4.pets,
    aboutPet = _ref4.aboutPet,
    _ref4$glm = _ref4.glm,
    glm = _ref4$glm === void 0 ? {} : _ref4$glm;
  var _ref5 = aboutPet !== null && aboutPet !== void 0 ? aboutPet : {},
    restrictedBreeds = _ref5.restrictedBreeds;
  return {
    firstName: owner.firstName,
    surname: owner.surname,
    dateofBirth: handleGlm3(glm, owner),
    day: owner.day,
    month: owner.month,
    year: owner.year,
    titleCode: owner.titleCode,
    titleName: owner.titleName,
    genderName: owner.genderName,
    genderId: owner.genderId,
    address: owner.address,
    suburb: owner.suburb,
    state: owner.state,
    postcode: owner.postcode,
    telephoneHome: owner.telephoneHome,
    telephoneWork: owner.telephoneWork,
    telephoneMobile: owner.telephoneMobile,
    email: owner.email,
    dpid: owner.dpid,
    barcode: owner.barcode,
    authorisedMemberFirstName: owner.authorisedMemberFirstName,
    authorisedMemberSurname: owner.authorisedMemberSurname,
    authorisedMemberDob: (0, _helpers.IsValidDate)(owner.authorisedMemberDob) ? (0, _helpers.DateToShortIsoString)(owner.authorisedMemberDob) : null,
    authorizedDay: owner.authorizedDay,
    authorizedMonth: owner.authorizedMonth,
    authorizedYear: owner.authorizedYear,
    hasAuthorisePerson: owner.hasAuthorisePerson,
    // hasInsuranceCancelled sets isReferToUnderwriter to true
    hasInsuranceCancelled: checkRestrictedBreeds(pets, restrictedBreeds),
    isEmailCommunicaton: (_owner$isEmailCommuni = owner.isEmailCommunicaton) !== null && _owner$isEmailCommuni !== void 0 ? _owner$isEmailCommuni : true,
    marketingConsent: (_owner$marketingConse = owner.marketingConsent) !== null && _owner$marketingConse !== void 0 ? _owner$marketingConse : null
  };
};
var handleMemberNumber = function handleMemberNumber(hasMemberNumber, savedMemberNumber, passThroughValue) {
  if (savedMemberNumber === passThroughValue) {
    return passThroughValue;
  }
  if (savedMemberNumber == null && hasMemberNumber) {
    return passThroughValue;
  }
  if (hasMemberNumber && savedMemberNumber !== null && savedMemberNumber !== passThroughValue) {
    return savedMemberNumber;
  }
  return savedMemberNumber;
};

/**
 *
 * @param {Object} quote from form context
 * @param {Object} savedQuote from session storage
 */
var prepare = function prepare(quote, savedQuote, _ref6) {
  var _basicOwnerDetails$ow, _savedQuote$paymentFr, _savedQuote$paymentFr2, _savedQuote$partners, _savedQuote$selectedP;
  var _ref6$partner = _ref6.partner,
    partner = _ref6$partner === void 0 ? _brands.DEFAULT_PARTNER : _ref6$partner,
    _ref6$broker = _ref6.broker,
    broker = _ref6$broker === void 0 ? _brands.DEFAULT_BROKER : _ref6$broker,
    staffPromos = _ref6.staffPromos,
    _ref6$glm = _ref6.glm,
    glm = _ref6$glm === void 0 ? {} : _ref6$glm,
    aboutPet = _ref6.aboutPet,
    basicOwnerDetails = _ref6.basicOwnerDetails;
  var pets = preparePets(quote.pets, {
    aboutPet: aboutPet
  });
  var owner = prepareOwner(quote.owner, {
    pets: pets,
    glm: glm,
    aboutPet: aboutPet
  });
  var hasMemberNumber = quote.hasMemberNumber,
    savedMemberNumber = quote.memberNumber,
    promotionCode = quote.promotionCode,
    promotionNo = quote.promotionNo,
    promotionMessage = quote.promotionMessage,
    hasValidPromotion = quote.hasValidPromotion;
  var memberNumber = handleMemberNumber(hasMemberNumber, savedMemberNumber, basicOwnerDetails === null || basicOwnerDetails === void 0 || (_basicOwnerDetails$ow = basicOwnerDetails.ownerMemberNumberInput) === null || _basicOwnerDetails$ow === void 0 ? void 0 : _basicOwnerDetails$ow.passThroughDefault);
  var hasPromotionCode = !!promotionCode;
  var hasMediaList = savedQuote === null || savedQuote === void 0 ? void 0 : savedQuote.hasMediaList;
  var selectedMediaListCode = savedQuote === null || savedQuote === void 0 ? void 0 : savedQuote.selectedMediaListCode;
  var selectedMediaListName = savedQuote === null || savedQuote === void 0 ? void 0 : savedQuote.selectedMediaListName;
  var hasRegularVet = savedQuote === null || savedQuote === void 0 ? void 0 : savedQuote.hasRegularVet;
  var regularVet = savedQuote === null || savedQuote === void 0 ? void 0 : savedQuote.regularVet;
  var regularVetCode = savedQuote === null || savedQuote === void 0 ? void 0 : savedQuote.regularVetCode;
  var minPolicyStartDate = (0, _quote.getMinPolicyStartDate)(pets);
  var policyStartDate = (0, _dayjs["default"])(savedQuote.policyStartDate).isValid() && (0, _dayjs["default"])(savedQuote.policyStartDate).isAfter((0, _dayjs["default"])(minPolicyStartDate)) ? savedQuote.policyStartDate : minPolicyStartDate;
  var paymentStartDate = (0, _quote.getPaymentStartDate)(policyStartDate);
  var externalId = (savedQuote === null || savedQuote === void 0 ? void 0 : savedQuote.externalId) || null;
  var preparedQuote = {
    paymentFrequency: (_savedQuote$paymentFr = savedQuote.paymentFrequency) !== null && _savedQuote$paymentFr !== void 0 ? _savedQuote$paymentFr : _constants.FREQUENCY_MONTHLY,
    paymentFrequencyCode: (_savedQuote$paymentFr2 = savedQuote.paymentFrequencyCode) !== null && _savedQuote$paymentFr2 !== void 0 ? _savedQuote$paymentFr2 : _constants.FREQUENCY_CODE_MONTHLY,
    owner: owner,
    pets: pets,
    appId: savedQuote === null || savedQuote === void 0 ? void 0 : savedQuote.appId,
    policyStartDate: (0, _helpers.DateToShortIsoString)(policyStartDate),
    paymentStartDate: (0, _helpers.DateToShortIsoString)(paymentStartDate),
    promotionNo: promotionNo !== null && promotionNo !== void 0 ? promotionNo : 0,
    partners: (_savedQuote$partners = savedQuote === null || savedQuote === void 0 ? void 0 : savedQuote.partners) !== null && _savedQuote$partners !== void 0 ? _savedQuote$partners : [{
      partnerName: partner,
      broker: broker
    }],
    selectedPartner: (_savedQuote$selectedP = savedQuote === null || savedQuote === void 0 ? void 0 : savedQuote.selectedPartner) !== null && _savedQuote$selectedP !== void 0 ? _savedQuote$selectedP : {
      partnerName: partner,
      broker: broker
    },
    isNew: true,
    web: true,
    telephone: false,
    faceToFace: false,
    hasPromotionCode: hasPromotionCode,
    promotionCode: promotionCode,
    hasValidPromotion: hasValidPromotion,
    promotionMessage: promotionMessage,
    hasMediaList: hasMediaList,
    selectedMediaListCode: selectedMediaListCode,
    selectedMediaListName: selectedMediaListName,
    memberNumber: hasMemberNumber === 'yes' ? memberNumber : null,
    hasRegularVet: hasRegularVet,
    regularVet: regularVet,
    regularVetCode: regularVetCode,
    externalId: externalId,
    hasMemberNumber: hasMemberNumber === 'yes'
  };
  var memberFieldSettings = basicOwnerDetails === null || basicOwnerDetails === void 0 ? void 0 : basicOwnerDetails.ownerMemberNumberInput;
  if (hasMemberNumber === 'yes' && memberFieldSettings && memberFieldSettings !== null && memberFieldSettings !== void 0 && memberFieldSettings.clientNumberTypeCode) {
    preparedQuote.owner.clientNumbers = [{
      clientNumberTypeCode: memberFieldSettings === null || memberFieldSettings === void 0 ? void 0 : memberFieldSettings.clientNumberTypeCode,
      number: memberNumber
    }];
  }
  if (Array.isArray(staffPromos) && staffPromos.includes(promotionCode)) {
    preparedQuote.owner.clientNumbers = [{
      clientNumberTypeCode: promotionCode,
      number: owner.email
    }];
  }
  return preparedQuote;
};
var quotePreparation = exports.quotePreparation = {
  prepare: prepare
};